import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function BooleanCheckmarkOrNull({ bool, ...iconProps }) {
  if (!bool) return null;
  return <FontAwesomeIcon icon="check" {...iconProps} />;
}
